import Vue from "vue";
import Vuex from "vuex";
import { getStore,getCookies } from "@/utils/utils";
import api from "@/fetch/api";
import Cookies from "js-cookie";
Vue.use(Vuex);


const state = {
  token: Cookies.get(`student_online_pc_token`) || "",
  auth:
    Cookies.get(`student_online_pc_auth`) || "teach",
  userInfo:
    (Cookies.get(`student_online_pc_userInfo`) && JSON.parse(Cookies.get(`student_online_pc_userInfo`))) || {},
  enums: {},
  dict: {},
  studentRoll: {},
  studentBase: {},
  chartInit: "",
  outLink: "",
  groupManager: "",
  sysSetting: {}
};

const mutations = {
  setAuth(state, auth) {
    state.auth = auth;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ENUMS: (state, enums) => {
    state.enums = enums;
  },
  SET_DICT: (state, dict) => {
    state.dict = dict;
  },
  SET_ROLL: (state, roll) => {
    state.studentRoll = roll;
  },
  SET_STUDENT: (state, studentBase) => {
    state.studentBase = studentBase;
  },
  SET_CHARTINIT: (state, chartInit) => {
    state.chartInit = chartInit;
  },
  SET_GROUP: (state, groupManager) => {
    state.groupManager = groupManager;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_OUTLINK: (state, outLink) => {
    state.outLink = outLink;
  },
  SET_SYS_SETTING: (state, sysSetting) => {
    state.sysSetting = sysSetting;
  }
};
const actions = {
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  setUserInfo({ commit }, userInfo) {
    commit("SET_USERINFO", userInfo);
  },
  setOutLink({ commit }, outLink) {
    commit("SET_OUTLINK", outLink);
  },
  setSysSetting({ commit }, sysSetting) {
    commit("SET_SYS_SETTING", sysSetting);
  },
  getEnumsList({ commit, state }) {
    return new Promise((resolve, reject) => {
      api
        .getEnumsList()
        .then((response) => {
          if (response.code !== 200) {
            return reject("请求失败，请联系开发人员");
          }
          commit("SET_ENUMS", response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDictList({ commit, state }) {
    return new Promise((resolve, reject) => {
      api
        .getDictList()
        .then((response) => {
          if (response.code !== 200) {
            return reject("请求失败，请联系开发人员");
          }
          commit("SET_DICT", response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMyRoll({ commit, state }) {
    return new Promise((resolve, reject) => {
      api
        .getMyRoll()
        .then((response) => {
          if (response.code !== 200) {
            return reject("请求失败，请联系开发人员");
          }
          commit("SET_ROLL", response.data || {});
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMyStudent({ commit, state }) {
    return new Promise((resolve, reject) => {
      api
        .getMyStudent()
        .then((response) => {
          if (response.code !== 200) {
            return reject("请求失败，请联系开发人员");
          }
          commit("SET_STUDENT", response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js